<template>
	<div>
		<Layout :navFixed="false" transparent="true" invert="true" fixed="true" hideCart="true">
			<div class="container pt-5 pb-5 mt-4">
				<OrderDetail :code="code" />
			</div>
		</Layout>
	</div>
</template>

<script>
import Layout from '@/components/Layout'
import OrderDetail from '@/components/ecommerce/OrderDetail'

export default {
	name: 'CheckoutDone',
	metaInfo: {
		title: 'Compra finalizada',
	},
	components: {
		Layout,
		OrderDetail,
	},
	data() {
		return {
			code: null,
		}
	},
	beforeMount() {
		this.code = this.$route.params.code
	},
	methods: {},
}
</script>

<style scoped></style>
